import styled from 'styled-components';
import Logo from '../../atoms/Logo';

export const Container = styled.button`
  border-width: 0px;
  background-color: transparent;

  &:active {
    opacity: ${({disabled}) => (disabled ? 0.5 : 0.8)};
  }
`;

export const Icon = styled(Logo)`
  margin-right: 5px;
  margin-left: 5px;
`;
